import { CheckCircleIcon } from "components/Icons";

function SetupStepMarker({ done, number }) {
  if (done) {
    return <CheckCircleIcon width={28} className="shrink-0 fill-emerald-600" />;
  }
  return (
    <span className="flex size-7 shrink-0 items-center justify-center rounded-full border border-neutral-300 text-sm font-semibold text-neutral-600">
      {number}
    </span>
  );
}

export default SetupStepMarker;
